export default __webpack_public_path__ + "static/media/info.d45f8411.svg";